import React, { useState } from "react";
import TestChatAppReportView from "components/ChatApp/TestChatAppReportView";
import AgentProfiler from "components/ChatApp/AgentReportView";
import AgentMonitor from "components/ChatApp/AgentMonitor";
import { Button, ButtonGroup } from "../../aible";
import { isEnabled } from "utils/featureFlags";
var MonitoringTab;
(function (MonitoringTab) {
    MonitoringTab["AGENT_PROFILE"] = "AGENT_PROFILE";
    MonitoringTab["AZ_TESTS"] = "AZ_TESTS";
    MonitoringTab["AGENT_MONITORING"] = "AGENT_MONITORING";
})(MonitoringTab || (MonitoringTab = {}));
const TestChatAppMonitoring = () => {
    const [monitoringTab, setMonitoringTab] = useState(MonitoringTab.AGENT_MONITORING);
    return (React.createElement("div", null,
        React.createElement("div", { style: { padding: "10px 12px", background: "#fff", position: "relative" } },
            React.createElement(ButtonGroup, null,
                React.createElement(Button, { onClick: () => setMonitoringTab(MonitoringTab.AGENT_MONITORING), active: monitoringTab === MonitoringTab.AGENT_MONITORING }, "Agent Monitoring"),
                React.createElement(Button, { onClick: () => setMonitoringTab(MonitoringTab.AZ_TESTS), active: monitoringTab === MonitoringTab.AZ_TESTS }, "A/Z Tests"),
                isEnabled("enable-agent-profile") && (React.createElement(Button, { onClick: () => setMonitoringTab(MonitoringTab.AGENT_PROFILE), active: monitoringTab === MonitoringTab.AGENT_PROFILE }, "Agent Profile")))),
        monitoringTab === MonitoringTab.AGENT_MONITORING && React.createElement(AgentMonitor, { data: [] }),
        monitoringTab === MonitoringTab.AZ_TESTS && React.createElement(TestChatAppReportView, null),
        monitoringTab === MonitoringTab.AGENT_PROFILE && React.createElement(AgentProfiler, null)));
};
export default TestChatAppMonitoring;
